
<div class="boundary">
    <div cdkDropList
        class="d-flex flex-column gap-space-16" data-clarity-mask="true"
        (cdkDropListDropped)="Dropped($event)">
        <div *ngFor="let item of sortedItemList"
            [attr.data-sb-qa]="item.qaTag"
            class="card padding-x-12 padding-y-8 d-flex justify-content-between flex-row align-items-center" cdkDragLockAxis="y"
            cdkDragBoundary=".boundary"
            cdkDrag [cdkDragDisabled]="disableDrag"
            [id]="item.id">

            <div *cdkDragPlaceholder class="payment-option-custom-placeholder"></div>
            <div cdkDragHandle class="payment-option-handle">
                @if (!disableDrag) {
                    <lib-icon [ngStyle]="{'visibility': 'inherit'}" class="neutral-500" [icon]="Icon.Common.DragIndicator"
                        [size]="IconSize.Medium"></lib-icon>
                }
            </div>
            <div  data-clarity-mask="true" style="min-width: 0;">
                <ng-container *ngTemplateOutlet="item.content"></ng-container>
            </div>

            <ng-container *ngTemplateOutlet="item.menu"></ng-container>
        </div>
    </div>
</div>
